import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import toLower from 'lodash/toLower';
import Button, { ButtonVariations } from '../../../../../../SolvPatternLibrary/Button';
import { fontFamily, fontSize } from '~/constants/text';
import { colors } from '~/constants/colors';
import { addAorAnToNoun } from '~/core/util/string';
import { Tile } from '../Tile';

const Root = styled.div.withConfig({ componentId: 'sc-cdb5uy-0' })`
  padding: 22px 24px;
`;

const Title = styled.div.withConfig({ componentId: 'sc-cdb5uy-1' })`
  color: ${colors.fadeToBlack};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.large};
`;

const Body = styled.div.withConfig({ componentId: 'sc-cdb5uy-2' })`
  margin: 12px 0;
  color: ${colors.lightText};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  align-self: center;
`;

const RecommendedContainer = styled.div.withConfig({ componentId: 'sc-cdb5uy-3' })`
  display: flex;
  justify-content: space-between;
`;

const Source = styled.img.withConfig({ componentId: 'sc-cdb5uy-4' })`
  max-width: 65px;
  object-fit: contain;
`;

const Okay = styled.div.withConfig({ componentId: 'sc-cdb5uy-5' })`
  text-align: right;
`;

const Confirm = styled(Button).withConfig({ componentId: 'sc-cdb5uy-6' })`
  padding: 8px 0 8px 16px;
  margin: 0;
  color: ${colors.blueJayWay};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.mediumSmall};
`;

type Props = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  onClose?: func;
  activeTile?: Tile | null;
};

export default class AdditionalInfo extends PureComponent<Props> {
  static MODAL_ID = 'additional-info';

  render() {
    const {
      onClose,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type 'object | ... Remove this comment to see the full error message
      activeTile: { title, info, recommendedBy, recommendedLogo },
    } = this.props;

    return (
      <Root>
        <Title>Why do I need {addAorAnToNoun(toLower(title))}?</Title>

        <Body>{info}</Body>

        <RecommendedContainer>
          <Body>Recommended by {recommendedBy}</Body>

          <Source alt={`logo for ${recommendedBy}`} src={recommendedLogo} />
        </RecommendedContainer>

        <Okay>
          <Confirm onClick={onClose} variation={ButtonVariations.link}>
            OK
          </Confirm>
        </Okay>
      </Root>
    );
  }
}
